export default __webpack_public_path__ + "static/media/13d.beb12471.svg";